<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6Ek6LG/tc-custom/9781467446266.jpg?1730409132662" alt="This image is the cover for the book A Shorter Guide to the Holy Spirit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Shorter Guide to the Holy Spirit
      </h1>
      <p class="bookDescription body article font2">
        <p>Anthony Thiselton’s scholarly book <i>The Holy Spirit — In Biblical Teaching, through the Centuries, and Today</i> was published to wide acclaim in 2013 and received a 2014 <i>Christianity Today</i> Book Award. This shorter volume makes Thiselton’s vast biblical-theological knowledge and brilliant insight more accessible to more readers.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony C. Thiselton
      </h2>
      
      <p class="authorDescription body article"> &#160; <B>Anthony C. Thiselton</B>&#160;(1937&ndash;2023) was professor of Christian theology at the University of Nottingham, England. His many books include&#160;<I>A Shorter Guide to the Holy Spirit, Systematic Theology</I>, and&#160;<I>Life after Death: A New Approach to the Last Things.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9e82eee